import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import {getCssVariable} from "../../../utilities/Helper";
import {ContainerEngine} from "../../../utilities/ContainerEngine";
import {onWindowResize} from "../../../utilities/Hooks";
import {mediaBreakpointDown} from "../../../utilities/MediaBreakpoints";

function computeContainerOffsetX() {
    if (mediaBreakpointDown('lg')) return;
    return ContainerEngine.find('xl').offsetX + parseInt(getCssVariable('--container-padding'));
}

function updateHeadingElementOffsetX(element) {
    element.style.marginLeft = `${computeContainerOffsetX()}px`;
}

function getNewSwiperInstance() {
    return new Swiper('#carouselIndustries', {
        modules: [Navigation, Pagination],
        pagination: {
            el: ".industries-pagination",
            clickable: true,
        },
        speed: 400,
        freeMode: {
            enabled: false,
            sticky: false,
        },
        navigation: {
            nextEl: '.swiper-industries-button-next',
            prevEl: '.swiper-industries-button-prev',
        },
        slidesPerView: 'auto',
        slidesOffsetBefore: 0,
        spaceBetween: 0,
        breakpoints: {
            991: {
                spaceBetween: 20,
                slidesOffsetBefore: computeContainerOffsetX,
            }
        }
    });
}

export default function setupCarouselIndustries() {
    if (document.querySelector('.section-industries') === null) return;
    const swiper = getNewSwiperInstance();
    if (mediaBreakpointDown('lg')) return;
    const industriesHeadingElement = document.querySelector('.section-industries__header');
    updateHeadingElementOffsetX(industriesHeadingElement);

    onWindowResize(() => {
        swiper.params.slidesOffsetBefore = computeContainerOffsetX();
        updateHeadingElementOffsetX(industriesHeadingElement);
    })
}
